import store from "@/store";

const routes = [
    {
        path: "/system/notification-settings",
        name: "notification-settings",
        component: () => import('@/views/main/SystemSettings/NotificationSettings.vue'),
        beforeEnter: (to, from, next) => {
            const user = store.getters['USERACCOUNT_LOAD']
            user && user.super_admin ? next() : next('/no-access')
        },
        meta: { requiresAuth: true, title: 'Notification Settings' },
    },
    {
        path: "/my-reminders",
        name: "my-reminders",
        component: () => import('@/views/main/modules/MyReminders.vue'),
        meta: { requiresAuth: true, title: 'My Reminders' },
    },
    {
        path: "/system-settings/navigation-drawer/:id",
        name: "navigationdrawer",
        component: () => import('@/views/main/SystemSettings/NavigationDrawer.vue'),
        beforeEnter:(to,from,next)=>{
            store.dispatch('checkAccessUser', to.params.id).then((response)=>{
                if(response == 'fail'){
                    next('/no-access')
                    }else{
                    next()
                }
            }).catch(()=>{

            })
        },
        meta:{
            requiresAuth:true,
            title:'Navigation Settings'
        }
    },
    {
        path: "/system-settings/general-settings/:id",
        name: "generalsettings",
        component: () => import('@/views/main/SystemSettings/GeneralSettingsComponent.vue'),
        beforeEnter:(to,from,next)=>{
            store.dispatch('checkAccessUser', to.params.id).then((response)=>{
                if(response == 'fail'){
                    next('/no-access')
                    }else{
                    next()
                }
            }).catch(()=>{

            })
        },
        meta:{
            requiresAuth:true,
            title:'General Settings'
        }
    },
]
export default routes;
